(function () {
  'use strict';

  function initialize() {
    document.querySelectorAll('[data-support-sms-consent]').forEach(function (checkbox) {
      if (checkbox.dataset.supportSmsBound) return;
      var form = checkbox.form;
      var phone = form && form.querySelector('[name="contact[telephone]"]');
      if (!phone) return;
      checkbox.dataset.supportSmsBound = 'true';
      var originallyRequired = phone.required;

      function synchronize() {
        phone.required = originallyRequired || checkbox.checked;
      }

      checkbox.addEventListener('change', synchronize);
      form.addEventListener('reset', function () { setTimeout(synchronize, 0); });
      window.addEventListener('pageshow', synchronize);
      synchronize();
    });
  }

  initialize();
  document.addEventListener('shopify:section:load', initialize);
}());
